import { render, staticRenderFns } from "./app-back.vue?vue&type=template&id=5760a5a2&"
import script from "./app-back.vue?vue&type=script&lang=js&"
export * from "./app-back.vue?vue&type=script&lang=js&"
import style0 from "./app-back.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports